module.exports = __webpack_public_path__ + "static/media/note.17c1bbd0.png";